module.exports = __webpack_public_path__ + "img/pcwire.2a28daac.png";